import { render } from "./HeadMenu.vue?vue&type=template&id=808b9af2"
import script from "./HeadMenu.vue?vue&type=script&lang=js"
export * from "./HeadMenu.vue?vue&type=script&lang=js"

import "./HeadMenu.vue?vue&type=style&index=0&id=808b9af2&lang=less"

import exportComponent from "/builds/fa4daba7/0/develop/front_payments_config/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__